import initNitro from "./lib/nitro";
import initMove, { submitMoveWithAction } from "./lib/move";
import { init as initHashTracking } from "./lib/hash-tracking";
import { init as initEchTracking } from "./lib/external-call-tracking";
import { init as initLinkData, trackOnNextPageImpression } from "./lib/link-data";
import {
  closeContext,
  createContext,
  createEventMergeContext,
  init as initBct,
  replaceContext,
} from "./lib/bct";
import {
  createPage,
  sendMiniActionsToGate,
  submitEvent,
  submitEventMerge,
  submitMerge,
  trackBlockedFeatures,
} from "./lib/request";
import { getPageId } from "./lib/url-helper";
import { init as initViewtimeTracking } from "./lib/viewtime";
import { onLoad, onReady } from "@otto-ec/global-resources/dom";
onLoad.subscribe(initNitro);
onReady.subscribe(initMove);
onReady.subscribe(initLinkData);
onReady.subscribe(initBct);
onReady.subscribe(initEchTracking);
onReady.subscribe(initHashTracking);
onReady.subscribe(initViewtimeTracking);
/*                   */
otto.tracking.assignNamespace({
  createPage,
  submitEvent,
  submitEventMerge,
  submitMerge,
  submitMove: (datacontainer, action) => {
    submitMoveWithAction(datacontainer, action);
  },
  submitMiniAction: async (updates) => {
    await sendMiniActionsToGate(updates);
  },
  createEventMergeContext,
  trackOnNextPageImpression: (datacontainer) => {
    trackOnNextPageImpression(datacontainer);
  },
  createContext: (id, url, datacontainer) => {
    createContext(id, url, datacontainer);
  },
  replaceContext: (id, url, datacontainer) => {
    replaceContext(id, url, datacontainer);
  },
  closeContext,
  getPageMergeId: getPageId,
  trackBlockedFeatures
});
